export enum AccessPaths {
  Content = 'content',
  Upload = 'upload',
  Requests = 'requests',
}

export enum AccessParams {
  RequestRef = 'requestRef',
  AudioSegmentId = 'audioSegmentId',
  StepName = 'stepName',
}

export enum ExternalUploadStepPath {
  CaseInformation = 'case-information',
  SelectFiles = 'select-files',
  RecordingDetails = 'recording-details',
  Upload = 'upload',
}
